const { REACT_APP_GOOGLE_MAPS_API_KEY } = process.env


export const API_KEY = REACT_APP_GOOGLE_MAPS_API_KEY